import { observer } from 'mobx-react';
import React, { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface IBarcodeScannerProps {
  onDecodeResult: (code: string) => void;
}

export const BarcodeScanner = observer(
  ({ onDecodeResult }: IBarcodeScannerProps) => {
    const scannerRef = useRef<Html5Qrcode | null>(null);
    const containerId = 'html5qr-code-full-region';

    useEffect(() => {
      scannerRef.current = new Html5Qrcode(containerId);

      scannerRef.current.start(
        { facingMode: 'environment' },
        {
          fps: 15, // Faster FPS helps with screen-scanning
          qrbox: { width: 350, height: 150 }, // Wide box for 1D coupons
          aspectRatio: 1.0,
        },
        (decodedText) => {
          onDecodeResult(decodedText);
        },
        () => {
          // No code found in frame
        },
      );

      return () => {
        if (scannerRef.current?.isScanning) {
          scannerRef.current.stop().then(() => scannerRef.current?.clear());
        }
      };
    }, [onDecodeResult]);

    return (
      <div className="scanner-wrapper">
        <div className="scanner-container position-relative mx-auto overflow-hidden rounded shadow-lg">
          <div id={containerId} />
        </div>
      </div>
    );
  },
);
